export enum EInquiryScoreColor
{
    Red = 0,
    Yellow = 1,
    Green = 2
}